import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
  styleUrls: ['./ads.component.scss'],
})
export class AdsComponent {

  ads: any = [];
  editId; 
  search:any=[];
  loader: boolean = false;
  orgObj: any;
  filterLength;
  orgName;
  adsUp:boolean=false;
  mobile:boolean=false;
  orgsData:any=[]
  orgId = localStorage.getItem('organizationId');

  constructor(private service: ApiService, 
    public handler: HandlerService,
    public router: Router, 
    protected sanitizer: DomSanitizer,
    private auth:AuthService,
    private bottomSheet: MatBottomSheet) { }

    ionViewWillEnter() {
      this.orgId = localStorage.getItem('organizationId');
      this.service.getOrg().subscribe((res:any)=>{
        this.orgsData=res;
        this.orgsData.map(res=>{
          if(res.id==this.orgId){
            this.orgName = res.name
          }
        }) 
      })
      this.service.getOrgAds(this.orgId).subscribe(res => {
        this.ads = res;
        this.loader = false
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })
    }
    
    
  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.orgsData,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
        this.orgName = res.name;
        this.orgId = res.id;
      }
    });
  }


    selectedId(id) {
      this.editId = id;
    }
    editAd() {
      this.router.navigate(['/edit-ad', this.editId]);
    }
    previewDesktopAd() {
      sessionStorage.setItem('desktop', "1");
      this.router.navigate(['/about-ad', this.editId]);
      this.adsUp = false ;
    }
    previewMobileAd() {
      sessionStorage.setItem('desktop', "2");
      this.router.navigate(['/about-ad', this.editId]);
      this.adsUp = false;
    }
 
    ionViewWillLeave(){
      this.ads=[];
      this.search = "";
  
    }
  
    popUp(){
     this.adsUp = true;
     this.mobile = true;
    }
    clear(){
      this.search="";
    }
    ngDoCheck(): void {
      this.filterLength = sessionStorage.getItem('len')
    
    }

}
